$('.layer-image').hide();
//desktop variables
var layerImage = $('.layer-image'),
    indexOne = $('.desktop-ban.index-1'),
    indexTwo = $('.desktop-ban.index-2'),
    indexThree = $('.desktop-ban.index-3'),
    indexFour = $('.desktop-ban.index-4'),
    indexFive = $('.desktop-ban.index-5'),
    indexSix = $('.desktop-ban.index-6'),
    indexSeven = $('.desktop-ban.index-7'),
    indexEight = $('.desktop-ban.index-8'),
    allLayers = $('.desktop-ban.index-1, .desktop-ban.index-2, .desktop-ban.index-3, .desktop-ban.index-4, .desktop-ban.index-5, .desktop-ban.index-6, .desktop-ban.index-7, .desktop-ban.index-8'),
    text = $('.text'),
    //mobile variable
    mIndexOne = $('.mobile-ban.index-1'),
    mIndexTwo = $('.mobile-ban.index-2'),
    mIndexThree = $('.mobile-ban.index-3'),
    mIndexFour = $('.mobile-ban.index-4'),
    mIndexFive = $('.mobile-ban.index-5'),
    mAllLayers = $('.mobile-ban.index-1, .mobile-ban.index-2, .mobile-ban.index-3, .mobile-ban.index-4, .mobile-ban.index-5');

function animateObjects() {
    //desktop animation
    layerImage.css('top', '0').fadeIn(300);
    indexOne.addClass('cssanimation fadeInTop').css({
        'animation-delay': '.5s',
        'animation-duration': '3.3s'
    });
    indexTwo.addClass('cssanimation fadeInTop').css({
        'animation-delay': '.5s',
        'animation-duration': '3s'
    });
    indexThree.addClass('cssanimation fadeInTop').css({
        'animation-delay': '.5s',
        'animation-duration': '2.7s'
    });
    indexFour.addClass('cssanimation fadeInTop').css({
        'animation-delay': '.5s',
        'animation-duration': '2.4s'
    });
    indexFive.addClass('cssanimation fadeInTop').css({
        'animation-delay': '.5s',
        'animation-duration': '1.9s'
    });
    indexSix.addClass('cssanimation fadeInTop').css({
        'animation-delay': '.5s',
        'animation-duration': '1.5s'
    });
    indexSeven.addClass('cssanimation fadeInTop').css({
        'animation-delay': '.5s',
        'animation-duration': '1.2s'
    });
    indexEight.addClass('cssanimation fadeInTop').css({
        'animation-delay': '.5s',
        'animation-duration': '.9s'
    });
    text.addClass('cssanimation fadeIn').css({
        'animation-delay': '.5s',
        'animation-duration': '1s'
    });
    //mobile animation
    mIndexOne.addClass('cssanimation fadeInTop').css({
        'animation-delay': '.5s',
        'animation-duration': '2.5s'
    });
    mIndexTwo.addClass('cssanimation fadeInTop').css({
        'animation-delay': '.5s',
        'animation-duration': '2.1s'
    });
    mIndexThree.addClass('cssanimation fadeInTop').css({
        'animation-delay': '.5s',
        'animation-duration': '1.8s'
    });
    mIndexFour.addClass('cssanimation fadeInTop').css({
        'animation-delay': '.5s',
        'animation-duration': '1.1s'
    });
    mIndexFive.addClass('cssanimation fadeInTop').css({
        'animation-delay': '.5s',
        'animation-duration': '.8s'
    });
}

function disableAnimate() {
    // desktop animation disable
    layerImage.css('top', '-200%').hide();
    allLayers.removeClass('cssanimation fadeInTop');
    text.removeClass('fadeIn');
    //mobile animation disable
    mAllLayers.removeClass('cssanimation fadeInTop');
}




// INITIATE SLIDESHOW
$(window).load(function() {
    $('.flex-desktop').flexslider({
        animation: "fade",
        prevText: '',
        nextText: '',
        slideshow: true,
        //animationSpeed:1000,
        //initDelay: 1000,
        slideshowSpeed: 3800,
        start: function() {
            $('#slider-wrapper .flexslider').css('background-image', 'none');
            $('.desktop-banner-preload, .mobile-banner-preload').hide();
            //$('.layer-image').css('top','0');
            //animateObjects();
        },
        before: function() {
            disableAnimate();
            //animateObjects();
            //alert('before');
        },
        after: function() {
            animateObjects();
            //alert('after');
        }
    });
});

// INITIATE SLIDESHOW
$(window).load(function() {
    $('.full-width-flex').flexslider({
        animation: "fade",
        prevText: '',
        nextText: '',
        slideshow: true,
        slideshowSpeed: 3000
    });
});

// INITIATE SLIDESHOW
$(window).load(function() {
    $('#article-slider').flexslider({
        animation: "fade",
        prevText: '',
        nextText: '',
        slideshow: false,
        slideshowSpeed: 3000,
        start: function() {
            // FUNTION FOR ARTICLE TEMPLATE 2
            $('.box-shop-container .small-box-content').hide();
            $('.box-shop-container .small-box-content:nth-child(1)').show();
            // FUNTION FOR ARTICLE TEMPLATE 2
        },
        after: function() {
            // FUNTION FOR ARTICLE TEMPLATE 2
            var totalItems = $('.slides li').length;
            var currentIndex = $('li.flex-active-slide').index() + 1;
            //alert(currentIndex);

            $('.box-shop-container .small-box-content').hide();
            $('.box-shop-container .small-box-content:nth-child(' + currentIndex + ')').show();
            // FUNTION FOR ARTICLE TEMPLATE 2
        },
    });
});

$(window).load(function() {
    $('.flex-mobile').flexslider({
        animation: "fade",
        prevText: '',
        nextText: '',
        slideshow: true,
        start: function() {
            $('#slider-wrapper .flexslider').css('background-image', 'none');
            $('.desktop-banner-preload, .mobile-banner-preload').hide();
            //$('.layer-image').css('top','0');
            animateObjects();
        },
        before: function() {
            disableAnimate();
        },
        after: function() {
            animateObjects();
        }
    });
});

// SUB MENU SHOW
$(document).ready(menu_init);
$(window).resize(loadNav);
$(window).load(loadNav);




function menu_init() {
    // Burger menu
    var $burger = $(".hamburger"),
        $overlay = $(".overlay");
    $burger.click(function() {
        $overlay.fadeToggle(200);
        $(this).toggleClass('is-active').toggleClass('btn-close');
    });
    $overlay.on('click', function() {
        $overlay.fadeToggle(200);
        $burger.toggleClass('is-active').toggleClass('btn-close');
        open = false;
    });

    $(".card-acq").html('<div class="cta-content"> <div> <div class="flbx-ct"> <h2>Get up to S$230 when you apply for a UOB Card now*!<br /></h2> <a target="_blank" href="https://www.uob.com.sg/credit-cards/">APPLY NOW</a> <span><sup>*</sup> Terms and conditions apply</span> </div> </div> </div> <img src="images/article-footer-banner.jpg" class="hidden-xs"> <img src="images/article-footer-banner-mob.jpg" class="visible-xs">');

    // $('.covid').load('partials/covid-warning.html', function() {
    //   loadNav();
    // });
    setTimeout(function(){
        $('#main-header').addClass('newheader').html('<div class="container-fluid sticky-container hidden"> <div class="sticky-banner"> <div class="container"> <div class="close-btn"><i class="glyphicon glyphicon-remove" id="closeSticky"></i></div> <h4><strong>Flattening The Curve</strong></h4> <p>As we all do our part to stay home and to stay safe, we encourage you to call or visit the websites of our merchant partners for operating details.</p> </div> </div> </div> <div class="container"> <div class="inner-wrapper"> <div class="logo-wrapper"> <a class="logo" target="_blank" href="https://www.uob.com.sg"><img alt="UOB" src="images/uob.png"></a></div> <div class="hamburger-wrapper"> <button class="btn-menu"><span class="glyphicon glyphicon-menu-hamburger" aria-hidden="true"></span></button></div> <div class="search-wrapper"> <div class="search-inner"> <input id="txt-search" class="nav-search" type="search" placeholder="Search for brand" onkeyUp="document.getElementById(\'printresults\').innerHTML = this.value"></div> <form id="search-form"> <div> <input id="txt-search" type="search" autocomplete="off" placeholder="Search for brand" onkeyUp="document.getElementById(\'printresults\').innerHTML = this.value"> <button class="reset" type="reset"><i class="fa fa-times"></i></button></div> </form> </div> <div class="brand-wrapper"><a href="index.html"> <picture> <source media="(max-width:500px)" srcset="images/ShopUOB-logo.png"> <img src="images/ShopUOB-logo.png" alt="The Mall by UOB Cards"></picture> </a></div> <div class="menu-wrapper"> <ul class="main-menu"> <li><a href="index.html" class="">Home</a></li> <li><a href="deals.html" class="">All deals</a></li> <li><a href="articles.html" class="">Get inspired</a></li> <li><a href="https://www.uob.com.sg/credit-cards/index.html" target="_blank" class="">Apply now</a></li> </ul> </div> </div> <div class="mobile-menu-wrapper"> <div class="hamburger-wrapper"> <button class="btn-close"><span class="glyphicon glyphicon-remove" aria-hidden="true"></span></button></div> <div class="menu-wrapper"> <div class="fake-search-wrapper"><input id="fake-search" type="search" placeholder="Search for brand"></div> <ul class="main-menu"> <li><a href="deals.html" class="">All deals</a></li> <li><a href="articles.html" class="">Get inspired</a></li> <li><a href="https://www.uob.com.sg/credit-cards/index.html" target="_blank" class="">Apply now</a></li> </ul> </div> </div> </div>');
            // $(this).css('padding-top', '0')
            $('.hamburger-wrapper .btn-menu').click(function(){
                $('.mobile-menu-wrapper').addClass('active');
            })

            $('.hamburger-wrapper .btn-close').click(function(){
                $('.mobile-menu-wrapper').removeClass('active');
            })

            $('#search-form').appendTo('#catch-search-form');
            $('#filter-records').addClass('newdeals-wrapper');

            var $menuTrigger = $('.main-menu .toggle-menu');

            $($menuTrigger).on('click mouseover', function() {
                $('.hidden-menu').stop().fadeIn(300);
            });

            $($menuTrigger).on('click mouseleave', function() {
                $('.hidden-menu').stop().fadeOut(300);
            });





            var thisPage = location.pathname;

            $('.newheader .main-menu a').each(function(){
                thisHref = $(this).attr('href');

                var patt = new RegExp(thisHref);

                if ( (thisPage == "" || thisPage == "/" || thisPage == "/index.html") && thisHref == "index.html") {
                    $(this).addClass('active');
                    // $('.sticky-container').addClass('hidden');
                } else if (patt.test(thisPage)) {
                    $(this).addClass('active');
                    // $('.sticky-container').removeClass('hidden');
                } else {
                    // console.log('others', thisPage, thisHref);
                    $(this).removeClass('active');
                    // $('.sticky-container').removeClass('hidden');
                }
            });

            if($("body").hasClass("home")){
              $('.newheader .main-menu li:first-child a').addClass('active');
            }

            // COVID

            $("#main-header").on('click', '.close-btn', function() {

                $(this).closest('.container-fluid').hide();
                $('#main-header').removeAttr('style');

                // setCookie('visited');
                setSessionStorage('covid', 1);

                setTimeout(loadNav, 300);
            });

            $('.sticky-container').removeClass('hidden');
            if (getSessionStorage('covid') != null) {

                $('.sticky-container').hide();
                // $('.page').trigger('custom-update')
                // $("#main-header").on("DOMNodeInserted", ".sticky-banner", function() {
                //     $(this).hide()
                // })
            }

            // if (thisPage == "/" || thisPage == "/index.html") {
            //     $('.sticky-container').hide();
            // } else {
            //     $('.sticky-container').removeClass('hidden');
            // }

            // loadNav();
            setTimeout(loadNav, 500);


      }, 500);

        $('#main-footer').addClass('newfooter').html('<div class="sticky-backtotop"> <a href="#" class="btn-backtotop"><img src="images/back-to-top.png" alt="Back to top"></a></div> <div class="sticky-applynow hidden"> <div class="wrapper"> <div class="wrapper-inner"> <div class="container"> <div class="row"> <div class="col-xs-12"> <div class="inner"> <div class="content"> <a class="btn-applynow" target="_blank" href="https://www.uob.com.sg/credit-cards/?ms=owned_site_sg&mt=product_bdefault&i_cid=shopuob_fixed_201807_na&vid=none&productid=cc">Get up to S$230 when you <em>apply</em> for a UOB Card now*! <span class="note">*T&Cs Apply.</span></a></div><span class="glyphicon glyphicon-remove btn-close" aria-hidden="true"></span> </div> </div> </div> </div> </div> </div> </div> <div class="container"> <div class="row"> <div class="col-xs-12"> <div class="footer-links"> <div class="footer-columns"> <div class="title">Explore More</div> <ul> <li><a href="https://www.uob.com.sg/personal/cards/index.page" target="_blank">Cards</a></li> <li><a href="https://www.uob.com.sg/personal/promotions/cards/index.page" target="_blank">More Privileges</a></li> <li><a href="https://www.uob.com.sg/personal/cards/payment-services/index.page" target="_blank">Payments &amp; Services</a></li> <li><a href="https://www.uob.com.sg/personal/borrow/personal-loan.page" target="_blank">Personal Loans</a></li> </ul> </div> <div class="footer-columns"> <div class="title">Useful Links</div> <ul> <li><a href="https://www.uob.com.sg/personal/cards/cards-usage/card-activation.page" target="_blank">Activate Your Card</a></li> <li><a href="https://www.uob.com.sg/personal/cards/cards-usage/overseas-card-use.page" target="_blank">Enable/Disable Overseas Usage</a></li> <li><a href="https://www.uob.com.sg/personal/cards/cards-usage/payment-modes.page" target="_blank">Payment Modes</a></li> <li><a href="https://www.uob.com.sg/personal/cards/credit-card-liability/faqs.page" target="_blank">Report Lost/Stolen Card</a></li> </ul> </div> <div class="footer-columns"> <div class="title">Others</div> <ul> <li><a href="https://www.uob.com.sg/personal/cards/credit-cards/terms-and-conditions.page" target="_blank">UOB Cardmembers\' Agreement</a></li> <li><a href="https://www.uob.com.sg/web-resources/personal/pdf/personal/cards/common/cards/gen-info-cards.pdf" target="_blank">General Information on UOB Cards</a></li> <li><a href="https://www.uob.com.sg/uob-branches-and-atms/locator.html" target="_blank">Visit any UOB Group Branch</a></li> </ul> </div> <div class="footer-columns"> <div class="title">Contact Us</div> <ul> <li>Call our 24-hour and toll-free hotline at 1800&nbsp;222&nbsp;2121 for&nbsp;queries.</li> </ul> </div> </div> </div> </div> <div class="row"> <div class="col-xs-12"> <div class="copyright"> Copyright &copy; 2020 United Overseas Bank Limited Co. Reg. No. 193500026Z. All Rights Reserved.</div> </div> </div> </div>');

            // Back to Top
            $('.btn-backtotop').click(function(){
                $('html, body').animate({
                    scrollTop: 0
                }, 300);
            })

            // Sticky Apply Now
            $('.sticky-applynow .btn-close').click(function(){
                setSessionStorage('applynow', 1);
                $('.sticky-applynow').addClass('hidden');
            })

            if (getSessionStorage('applynow') == null) {
                $('.sticky-applynow').removeClass('hidden');
            }

            if ($('.sticky-applynow').length > 0) {
                $('.sticky-applynow').css('min-height', '');
                $('.sticky-applynow').css('min-height', $('.sticky-applynow .wrapper-inner').outerHeight());

            }

            loadNav();





    // $('.mobile-menu').load('partials/header-menu-mob.html', function() {
    //     // TOGGLE MOBILE MENU
    //     $('.hamburger').click(function() {
    //         $('.mobile-menu').slideToggle(300);
    //     });

    //     $('.mobile-menu .toggle-menu > a').click(function() {
    //         $('.mobile-menu .hidden-menu').slideToggle(300);
    //     });

    //     $('.mobile-menu .toggle-menu a').click(function() {
    //         $(this).addClass('active-item');
    //     });
    // });

}



function loadNav() {

    if ($(window).width() <= 992) {
        $('.search-result-holder').attr('id', 'control-scroll');
        $('#catch-search-form .reset').text('close');

    }

    // console.log($(window).width());
    if ($('header').hasClass('newheader')) {
        // console.log("$('header').outerHeight()", $('header').outerHeight());
        $('.page').css('padding-top', Math.floor($('header').outerHeight())-1);
        if ($(window).width() >= 992) {
            $('.search-result-holder').css('padding-top', Math.floor($('header').outerHeight())-1);
        } else {
            $('.search-result-holder').css('padding-top', '');
        }
    }






}

//TOGGLE CLASS TO HEADER
//if ( $(window).width() >= 768) {
jQuery(window).on('scroll', function() {
    var fromTop = jQuery(window).scrollTop();
    jQuery('#main-header').toggleClass('active-header', (fromTop > 20));
    jQuery('.mobile-menu').toggleClass('active-scroll', (fromTop > 40));
});
//};




$(document).ready(function() {
    //hide arrows and disable swipe
    //console.log($('.home-page-slider > li').length);
    if($('.home-page-slider > li').length <= 1){
        $('#masthead-custom-nav').hide();
        $("#carousel-masthead").flexslider({
            touch : false
        });
    }

    $("#getinspired-slider").flexslider({
        // animation: "fade",
        // prevText: "",
        // nextText: "",
        // slideshow: !0,
        // slideshowSpeed: 3e3
        animation: "slide",
        customDirectionNav: $("#inspired-custom-nav a"),
    });

    $("#carousel-masthead").flexslider({
        // animation: "fade",
        // prevText: "",
        // nextText: "",
        // slideshow: !0,
        // slideshowSpeed: 3e3
        animation: "slide",
        slideshowSpeed: 15000,
        pauseOnAction: true,
        customDirectionNav: $("#masthead-custom-nav a"),
        //touch : $('.home-page-slider > li').length > 3
    });



    $('#catch-search-form #txt-search').bind('keypress', function() {
        $('#filter-records').html('');
        $('html, body').animate({
            scrollTop: $('#target').offset().top - 20 //#DIV_ID is an example. Use the id of your destination on the page
        }, 'slow');
        $('html,body').attr('style', '-webkit-overflow-scrolling : touch !important; overflow: auto !important; height: 100% !important;');
    });

    $('#catch-search-form #txt-search').blur(function() {
        $('html,body').attr('style', '');
    });




    var hammertime = $(".search-result-holder").hammer({
        threshold: 1
    });
    hammertime.on('pan', function(event) {
        $('#catch-search-form #txt-search').blur();
        $('html,body').attr('style', '');

    });

    $.ajax({
        type: "GET",
        url: "deals-master.csv",
        dataType: "text",
        success: function (e) {
            data1 = $.csv.toObjects(e)
        }
    });

    // $.ajax({
    //     type: "GET",
    //     url: "deals-ultimate-gift-guide.csv",
    //     dataType: "text",
    //     success: function (e) {
    //         data2 = $.csv.toObjects(e)
    //     }
    // });


    $(document).on("keyup", "#catch-search-form #txt-search", function(e) {

        //var alldata = data1.concat(data2);
        var searchField = $(this).val();
        if (searchField === '') {
            //$('.search-result-holder, .web_mask').fadeOut(300);
            $('#filter-records').html('');
            //   $('html, body').animate({
            //   scrollTop: $('#target').offset().top - 0 //#DIV_ID is an example. Use the id of your destination on the page
            // }, 'slow');
            if ($('#control-scroll #filter-records').empty) {
                $('html,body').attr('style', '-webkit-overflow-scrolling : touch !important; overflow: auto !important; height: 100% !important;');
            } else('not empty');
            return;
        }

        var regex = new RegExp(searchField, "i");
        var output = '<div>';
        var count = 1;

        $.each(data1, function(key, val) {
                var dealsOutlet = '';
                var validity = '';
                var price = '';
                var btn = '';
                var promoCode = '';
                var ultimateDealsOutlet = '';
                var subPrice = '';
                var tncsection = '';
                var promodesc = '';
            if ("Merchant" in val) {
                if ((val.Merchant.search(regex) != -1)) {
                    if(val.Outlets){
                        dealsOutlet ='<div class="outlet">' + '<span class="label-outlet-trigger">' + 'Locations [+]' + '</span> <div class="oc-hidden">' + val.Outlets + '</div>' + '</div>';
                    }
                    if(val['End date']){
                     validity = '<div class="validity"> Valid till' + val["End date"] + '</div>';
                    }

                    output += '<div class="loader-item ' + val['Online/Instore'] + ' ' + val['Online/Instore'] + '' + val.Category + ' ' + val.Category + ' all">'
                    output += '<span class="item-label">' + val.Tag + '</span>'
                    output += '<div class="item-card deal-card">'
                    //'<h3 class="termporary">'+val.Category+' '+val['Online/Instore']+'</h3>'+ // temporary
                    output += '<a href="deal-detail.html?id='+string_to_slug(val.Merchant)+'-'+val.Id+'">' + '<img src="images/gss/' + val.Image + '"/>' + '</a>'
                    output += '<div class="text-area-content">'
                    output += '<div class="featured-item-name-holder">'
                    output += '<span class="item-name item-name-small">'
                    output += '' + val.Merchant + ''
                    output += '</span>'
                    output += '</div>'
                    output += '<div class="clearfix">' + '</div>'
                    output += '<div class="deals-content">'
                    //'<span class="bullet-list">' + 'Promo' + '</span>' +
                    output += '<span class="promo-code">' + val.Promo + '</span>'
                    output += ''+ dealsOutlet +''
                    output += '<div class="tnc" style="font-size:8px">'+ validity +'<br><em>' + 'Terms and conditions apply' + '</em>'
                    output +='</div>'
                    // output += '<div class="terms-hidden">' + val['T&Cs'] + '</div>'
                    output += '<a class="btn-round right-chevron" href="deal-detail.html?id='+string_to_slug(val.Merchant)+'-'+val.Id+'">' + 'FIND OUT MORE' + '</a>'
                    output += '</div>'
                    output += '</div>'
                    output += '</div>'
                    output += '</div>'
                    // output += '<p>' + val.Category + '</p>'
                }
            }else if((val.Brand.search(regex) != -1) || (val.Title.search(regex) != -1)){
                if(val['Unidollar'].length  > 0){
                    price = '<div class="price"> UNI$' + val["Unidollar"] + '</div>';
                }else{
                    var dealprice = "";
                    var price_regex = /[,\s]/g;
                    var strPrice = val["Price"];

                    if(!strPrice.includes("-") && !strPrice.includes("From") && !strPrice.includes("to")){
                        var numberPrice = Number(strPrice.replace(price_regex, ''));
                        if(numberPrice%1 !== 0){
                            dealprice = numberPrice.toFixed(2);
                            //console.log(dealprice)
                        }else{
                            dealprice = numberPrice;
                        }
                        price = '<div class="price"> S$' + dealprice + '</div>';
                    }else{
                        price = '<div class="price">' + val["Price"] + '</div>';
                    }

                }
                if(val['Outlets']){
                    ultimateDealsOutlet ='<div class="outlet">' + '<span class="label-outlet-trigger">' + 'Locations [+]' + '</span> <div class="oc-hidden">' + val.Outlets + '</div>' + '</div>';
                }

                if(val['Price Sub text']){
                    subPrice ='<div class="subprice">'+ val['Price Sub text']+'</div>';
                }
                if(val['End date'] && val['End date'] != "-"){
                    validity = '<div class="validity"> Valid till' + val["End date"] + '</div>';
                }
                if(val['Button Type']){
                    btn = '<div class="cta-wrapper"><a class="btn-round right-chevron" href="javascript:myFunction(\'SG\',\''+val['CTA Shop Now']+'\')">'+val['Button Type']+'</a></div>';
                }
                if(val['Promo code']){
                    promoCode = '<div class="promo-code"> Promo code: ' + val["Promo code"] + '</div>';
                }
                if(val['Deals Detail URL'] && val['Deals Detail URL'] !== "-"){
                    tncsection = '<span>' + 'Terms and conditions apply, ' + ' full details <a href="'+val['Deals Detail URL']+'">here</a>.</span>';
                }else{
                    tncsection = '<span>Terms and conditions apply.</span>'
                }
                if(val['Promo Description'] && val['Promo Description'] !== "-"){
                    promodesc = '<div class="promo-desc">' + val['Promo Description']+ '</div>';
                }
                if(val['Featured'] === "yes"){
                    imgSection = '<img src="images/ultimate/' + val.Image + '"/>' +'<div class="featured">Featured</div>';
                    // if(val['Deals Detail URL']){
                    //     imgSection = '<a href="deal-detail.html'+val['Deals Detail URL']+'">' + '<img src="images/ultimate/' + val.Image + '"/>' + '</a>'+'<div class="featured">Featured</div>';
                    // }else{
                    //     imgSection = '<img src="images/ultimate/' + val.Image + '"/>' +'<div class="featured">Featured</div>';
                    // }

                }else{
                    imgSection = '<img src="images/ultimate/' + val.Image + '"/>';
                    // if(val['Deals Detail URL']){
                    //     imgSection = '<a href="deal-detail.html'+val['Deals Detail URL']+'">' + '<img src="images/ultimate/' + val.Image + '"/>' + '</a>'
                    // }else{
                    //     imgSection = '<img src="images/ultimate/' + val.Image + '"/>';
                    // }

                }
                   output += '<div class="loader-item ultimate">'
                   output += '<span class="item-label">' + val.Tag + '</span>'
                   output += '<div class="item-card deal-card">'
                   output += '<div>'
                   output += ''+imgSection+''
                   output += '<div class="featured-home">Festive Gift Guide</div>'
                   output += '</div>'
                   output += '<div class="text-area-content">'
                   output += '<div class="featured-item-name-holder">'
                   output += '<span class="item-name item-name-small">'
                   output += '' + val.Brand + ''
                   output += '</span>'
                   output += '<div class="item-name item-name-small">'
                   output += '' + val.Title + ''
                   output += '</div>'
                   output += '</div>'
                   output += '<div class="clearfix">' + '</div>'
                   output += '<div class="deals-content">'
                   output += '<span class="product-desc">' + val['Product Description']+ '</span>'
                   output += '<div class="price-wrapper">'
                   output += '' + price + ''
                   output += ''+ subPrice +''
                   output += '</div>'
                   output += ''+btn+''
                   output += '<div class="spacer">' + '</div>'
                   output += '<div class="card-exclusive">UOB Cards Exclusive:</div>'
                   output += ''+ promodesc +''
                   output += ''+promoCode+''
                   output += ''+ ultimateDealsOutlet +''
                   output += '<div class="tnc" style="font-size:8px">'+ validity +'<br>'
                   output += ''+tncsection+''
                   output +='</div>'

                   output += '</div>'
                   output += '</div>'
                   output += '</div>'
                   output += '</div>'
                   // output += '<p>' + val.Category + '</p>'
            }

        });
        output += '</div>';
        $('#filter-records').html(output);
    })
});
$(".fashion-and-beauty .item-label,.family-and-wellness .item-label, .home-and-electronics .item-label, .marketplaces-and-services .item-label ").remove();

$(document).on("click", "#fake-search", function(e) {
    $('.search-result-holder, .web-mask').fadeIn(200);
    $('.search-result-holder, .web_mask').css({
        'display': 'block',
        'z-index': '999'
    });
    $('#catch-search-form #txt-search').focus();
    // $('.page').css('opacity','0');
});


var titleSearch = $('.search-title');

$(document).on("keyup", "#catch-search-form #txt-search", function(e) {
    titleSearch.fadeIn(300);
    if (!this.value) {
        titleSearch.hide();
        $('#catch-search-form #txt-search').blur();
    }
    // $('.search-result-holder, .web_mask').fadeIn(300);
    $('.reset').fadeIn(200);
});

$(document).on("click", "#catch-search-form .reset", function(e) {
    titleSearch.hide();
    $('.search-result-holder, .web_mask').hide();
    // $('.page').css('opacity','1');

});

$(document).on("click", "#fake-search", function(e) {
    $('.mobile-menu').css('display', 'none');
    $('.hamburger').attr('class', 'hamburger hamburger--squeeze');
    $('#filter-records').html('');
});




$(document).on("click", ".trigger", function(e) { //#A_ID is an example. Use the id of your Anchor
    $('html, body').animate({
        scrollTop: $('#target').offset().top - 120 //#DIV_ID is an example. Use the id of your destination on the page
    }, 'slow');
});

$(window).scroll(function() {
    if ($(this).scrollTop() > 100) {
        $('.trigger').stop().fadeIn(300);
    } else {
        $('.trigger').stop().fadeOut(500);
    }

    if ($('.sticky-applynow').length > 0) {
        // console.log($(this).scrollTop()+ $(this).height(), $('.sticky-applynow').offset().top + $('.sticky-applynow').height());
        if ($(this).scrollTop() + $(this).height() > $('.sticky-applynow').offset().top + $('.sticky-applynow').height()) {
            $('.sticky-applynow').removeClass('sticky');
        } else {
            $('.sticky-applynow').addClass('sticky');
        }

    }

    if ($('.sticky-backtotop').length > 0) {
        // console.log($(this).scrollTop()+ $(this).height(), $('.sticky-applynow').offset().top + $('.sticky-applynow').height());
        // if ($(this).scrollTop() + $(this).height() > $('.sticky-applynow').offset().top + $('.sticky-applynow').height()) {
        //     $('.sticky-applynow').removeClass('sticky');
        // } else {
        //     $('.sticky-applynow').addClass('sticky');
        // }
        if ($(this).scrollTop() > $(this).height() * 0.5) {
            $('.sticky-backtotop').removeClass('hidden');
            if ($('.sticky-applynow').is(':visible')) {
                $('.sticky-backtotop').css('bottom', $('.sticky-applynow').outerHeight() + 10);
            }
        } else {
            $('.sticky-backtotop').addClass('hidden');
        }

    }
});

$('a').each(function() {
    var href = $(this).attr('href');
    if ($(this).attr('href')) {
        var href1 = href.replace("javascript:", "");
        $(this).attr("onclick", href1);
    }
});


function setSessionStorage(e, a) {
    sessionStorage.setItem(e, a)
}

function getSessionStorage(e) {
    return sessionStorage.getItem(e)
}

function eraseSessionStorage(e) {
    sessionStorage.removeItem(e)
}

function deleteSessionStorage() {
    sessionStorage.clear()
}

$(document).ready(function() {}), $(document).ready(function() {
    $(".page-nav").click(function(e) {
        e.preventDefault();
        scrollToElem($(this).data("href"));
    });
    loadNav();
});

function scrollToElem(e) {
    $("html, body").animate({
        scrollTop: $(e).offset().top - $("header").outerHeight()
    }, 300)
}









function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}



function string_to_slug (str) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();

    // remove accents, swap ñ for n, etc
    var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
    var to   = "aaaaeeeeiiiioooouuuunc------";
    for (var i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

    return str;
}
